export enum MelioStatus {
    BANK_ACTIVATED = "BANK_ACTIVATED",
    BANK_NOT_ACTIVATED = "BANK_NOT_ACTIVATED",
    CREDIT_CARD = "CREDIT_CARD"
}